"use strict";

require("core-js/modules/es6.object.assign");

var _toConsumableArray = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          & > * {\n            margin-left: ", "px;\n            margin-right: ", "px;\n          }\n\n          & > :first-child {\n            margin-left: 0;\n            margin-right: ", "px;\n          }\n\n          & > :last-child {\n            margin-left: ", "px;\n            margin-right: 0;\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      display: flex !important;\n      align-items: center;\n      justify-content: flex-start;\n      margin: 0;\n\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var react_select_1 = require("react-select");

var styled_1 = require("./styled");

var Wrapper = styled_components_1["default"](react_select_1.components.SingleValue)(_templateObject(), function (props) {
  var theme = props.theme,
      selectProps = props.selectProps,
      children = props.children;
  var small = selectProps.size === "small";
  var multiple = children && Object.keys(children).length > 1;
  return styled_components_1.css(_templateObject2(), multiple && styled_components_1.css(_templateObject3(), small ? theme.spacing.unit / 2 : theme.spacing.unit, small ? theme.spacing.unit / 2 : theme.spacing.unit, small ? theme.spacing.unit / 2 : theme.spacing.unit, small ? theme.spacing.unit / 2 : theme.spacing.unit));
});

var SingleValue = function SingleValue(_a) {
  var selectProps = _a.selectProps,
      data = _a.data,
      rest = __rest(_a, ["selectProps", "data"]);

  var valueItems = selectProps.valueItems,
      _selectProps$size = selectProps.size,
      size = _selectProps$size === void 0 ? "default" : _selectProps$size;
  var image = data.image,
      label = data.label,
      value = data.value;
  var childComponents = Object.keys(valueItems).reduce(function (prev, key) {
    var type = valueItems[key];
    var dataVal = data[key];
    if (type === "text") return [].concat(_toConsumableArray(prev), [react_1["default"].createElement(styled_1.Name, null, dataVal)]);
    if (type === "image") return [].concat(_toConsumableArray(prev), [data[key] && typeof data[key] === "object" ? data[key] : react_1["default"].createElement(styled_1.Image, {
      src: dataVal,
      alt: data.label
    })]);
    if (type === "code") return [].concat(_toConsumableArray(prev), [react_1["default"].createElement(styled_1.Code, null, dataVal)]);
    return prev;
  }, []);
  return react_1["default"].createElement(Wrapper, Object.assign({
    data: data,
    selectProps: selectProps
  }, rest), childComponents.length > 0 ? childComponents : react_1["default"].createElement(react_1["default"].Fragment, null, size === "small" && react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(styled_1.Name, {
    style: {
      color: "#6A717F"
    }
  }, value.toUpperCase())), size === "default" && react_1["default"].createElement(react_1["default"].Fragment, null, image && typeof image === "object" ? image : react_1["default"].createElement(styled_1.Image, {
    src: image,
    alt: label
  }), react_1["default"].createElement(styled_1.Name, null, label), value && react_1["default"].createElement(styled_1.Code, null, value))));
};

exports["default"] = SingleValue;